var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatistics({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.18421 9.7661L5.5656 7.3847L7.5452 9.365L9.7551 7.1551L8.5 5.9H12V9.4L10.7449 8.1449L7.5452 11.3446L5.5656 9.365L3.8331 11.0968C4.61949 12.2804 5.82644 13.1208 7.20937 13.4476C8.59229 13.7745 10.0478 13.5634 11.2808 12.8571C12.5139 12.1508 13.4323 11.0021 13.8501 9.64389C14.2678 8.28564 14.1535 6.81938 13.5304 5.54225C12.9073 4.26512 11.8219 3.27264 10.4943 2.76592C9.16672 2.2592 7.69612 2.27615 6.38053 2.81333C5.06495 3.35051 4.00279 4.36774 3.40928 5.65889C2.81577 6.95004 2.73531 8.41854 3.18421 9.7668V9.7661ZM2.10761 10.8567L2.10061 10.8497L2.10341 10.8469C1.70436 9.95091 1.49875 8.98084 1.50001 8C1.50001 4.1339 4.6339 1 8.5 1C12.3661 1 15.5 4.1339 15.5 8C15.5 11.8661 12.3661 15 8.5 15C5.651 15 3.20101 13.299 2.10761 10.8567Z",
    fill: "#6B758B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics);
export default __webpack_public_path__ + "static/media/statistics.e30aa3b4c34fa14a330bb3b6ded22c91.svg";
export { ForwardRef as ReactComponent };